// Cross-form Validator
import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

// Validates if a description for Discovered PSP Via "Other" is required for a customer.
//  Requires the FormGroup's FormControl names for the customer to be:
//  1. discoveredVia
export const monitoringCellPhoneRequiredValidator: ValidatorFn = (
    control: AbstractControl,
): ValidationErrors | null => {
    let sendSMS = control.get('enrolledInSms')?.value;
    let cellNumber = control.get('cellPhoneNumber')?.value;
    let isValid = false;
    if (sendSMS === true) {
        isValid = cellNumber?.length > 0;
    } else {
        isValid = true;
    }
const hasRequiredError = isValid === false;
    return hasRequiredError
        ? { cellRequired: true }
        : null;
};